import React, { useEffect, useState } from 'react';
import PageLayout from 'components/common/PageLayout';
import ComissaoCobranca from '../components/ComissaoCobranca';
import './Cobranca.css';

/** Diretoria de Cobrança. Hoje tem uma tela só: a comissão da cobrança interna da MOV. */
const Cobranca = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    document.documentElement.classList.add('cobranca-resultados');
    return () => document.documentElement.classList.remove('cobranca-resultados');
  }, []);

  return (
    <PageLayout rootClassName="theme-bg !overflow-visible" mainClassName="!overflow-visible" showRefreshButton customRefreshFunction={async () => setRefreshKey((k) => k + 1)}>
      <div className="mx-auto max-w-[90rem] px-1.5 py-6 sm:px-2 lg:px-3">
        <div className="space-y-5">
          <div className="mb-5">
            <h1 className="text-2xl font-semibold tracking-tight text-[color:var(--text-primary)]">Resultados da cobrança</h1>
            <p className="text-sm text-[color:var(--text-muted)]">MOV Fibra · recuperação e comissão da cobrança interna</p>
          </div>
          <ComissaoCobranca refreshKey={refreshKey} />
        </div>
      </div>
    </PageLayout>
  );
};

export default Cobranca;
